/**
 * Tenant-configurable launch navigation for frontline workers.
 *
 * This is navigation curation, not an entitlement grant. Route RBAC, module
 * gates and RLS remain authoritative. The profile deliberately excludes
 * clinical/provider operations while retaining the worker jobs needed for a
 * roster-first go-live.
 */

export const FRONTLINE_SELF_SERVICE_ONLY_KEY = 'frontlineSelfServiceOnly';

const FRONTLINE_SELF_SERVICE_ROLES = new Set([
  'CARE_WORKER',
  'PERSONAL_CARE_WORKER',
  'ASSISTANT_IN_NURSING',
  'DOMESTIC_WORKER',
  'LIFESTYLE_OFFICER',
  'SOCIAL_SUPPORT_WORKER',
  'REGISTERED_NURSE',
  'ENROLLED_NURSE',
  'ALLIED_HEALTH',
  'ALLIED_HEALTH_PROFESSIONAL',
  'AGENCY_CONTRACTOR',
]);

const FRONTLINE_SELF_SERVICE_PATHS = new Set([
  '/overview',
  '/me/roster',
  '/me/hours',
  '/me/timesheets',
  '/me/messages',
  '/me/leave',
  '/me/shift-offers',
  '/me/shift-swaps',
  '/me/work-readiness',
  '/me/onboarding',
  '/help',
]);

function normalizedPath(href: string): string {
  const path = href.split(/[?#]/)[0] || '/';
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function isFrontlineSelfServiceRole(role: string | null | undefined): boolean {
  return Boolean(role && FRONTLINE_SELF_SERVICE_ROLES.has(role.toUpperCase()));
}

export function isFrontlineSelfServiceNavigationVisible(input: {
  href: string;
  role: string | null | undefined;
  enabled: boolean;
}): boolean {
  if (!input.enabled || !isFrontlineSelfServiceRole(input.role)) return true;
  const path = normalizedPath(input.href);
  return FRONTLINE_SELF_SERVICE_PATHS.has(path);
}
